<template>
  <!--begin::Menu wrapper-->
  <div
    class="header-menu align-items-stretch"
    data-kt-drawer="true"
    data-kt-drawer-name="header-menu"
    data-kt-drawer-activate="{default: true, lg: false}"
    data-kt-drawer-overlay="true"
    data-kt-drawer-width="{default:'280px', '300px': '300px'}"
    data-kt-drawer-direction="end"
    data-kt-drawer-toggle="#kt_header_menu_mobile_toggle"
    data-kt-place="true"
    data-kt-place-mode="prepend"
    data-kt-place-parent="{default: '#kt_body', lg: '#kt_header_nav'}"
  >
    <!--begin::Menu-->
    <div
      class="menu menu-lg-rounded menu-column menu-lg-row menu-state-bg menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-400 fw-bold my-3 my-lg-0 align-items-stretch px-3 px-lg-0"
      id="#kt_header_menu"
      data-kt-menu="true"
    >
      <template v-for="(item, i) in MainMenuConfig" :key="i">
        <template v-if="!item.heading">
          <template v-for="(menuItem, j) in item.pages" :key="j">
            <div
              v-if="menuItem.heading"
              class="menu-item menu-lg-down-accordion me-lg-1"
            >
              <router-link :to="menuItem.route" v-slot="{ href, navigate, isActive }">
                <a
                  :href="href"
                  class="menu-link py-3"
                  @click="navigate"
                  :class="{ active: isActive }"
                >
                  <span class="menu-title text-category">{{
                    translate(menuItem.heading)
                  }} </span>
                </a>
              </router-link>
            </div>
          </template>
        </template>
        <div
          v-if="item.heading"
          data-kt-menu-trigger="click"
          data-kt-menu-placement="bottom-start"
          class="menu-item menu-lg-down-accordion me-lg-1"
        >
          <span
            class="menu-link py-3"
            :class="{ active: checkActive(item.heading) }"
          >
            <!-- {{item.heading}} -->
            <span class="menu-title text-category">{{
              translate(item.heading)
            }}</span>
            <!-- <span class="svg-icon svg-icon-6 mx-2"> -->
              <!-- <inline-svg
                v-if="route.path.indexOf('mandatory-list') > -1"
                :src="`media/icon-app/arrow-down.svg`"
              />
              <inline-svg v-else :src="`media/icon-app/arrow-down.svg`" /> -->
             
            <!-- </span> -->
             <span class="svg-icon svg-icon-4 mx-2 menu-arrow-icon">
                <inline-svg :src="`media/icon-app/arrow-down.svg`" />
              </span>
          </span>
          <div
            class="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-rounded-0 py-lg-4 w-lg-250px"
          >
            <!-- loop menu dropdown -->
            <template v-for="(menuItem, j) in item.pages" :key="j">
              <!-- {{menuItem}} -->
              <div
                v-if="menuItem.sectionTitle"
                data-kt-menu-trigger="{default:'click', lg: 'hover'}"
                data-kt-menu-placement="right-start"
                class="menu-item menu-lg-down-accordion"
              >
                <span
                  class="menu-link py-3"
                  :class="{ active: hasActiveChildren(menuItem.route) }"
                >
                  <span class="menu-icon">
                    <i
                      v-if="headerMenuIcons === 'font'"
                      :class="menuItem.fontIcon"
                      class="bi fs-3"
                    ></i>
                    <span
                      v-if="headerMenuIcons === 'svg'"
                      class="svg-icon svg-icon-2"
                    >
                      <inline-svg :src="menuItem.svgIcon" />
                    </span>
                  </span>
                  <span class="menu-title text-category">{{
                    translate(menuItem.sectionTitle)
                  }}</span>
                  <span class="menu-arrow"></span>
                </span>
                <div
                  class="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px"
                >
                  <template v-for="(menuItem1, k) in menuItem.sub" :key="k">
                    <div
                      v-if="menuItem1.sectionTitle"
                      data-kt-menu-trigger="{default:'click', lg: 'hover'}"
                      data-kt-menu-placement="right-start"
                      class="menu-item menu-lg-down-accordion"
                    >
                      <span
                        class="menu-link py-3"
                        :class="{ active: hasActiveChildren(menuItem1.route) }"
                      >
                        <span class="menu-bullet">
                          <span class="bullet bullet-dot"></span>
                        </span>
                        <span class="menu-title text-category">{{
                          translate(menuItem1.sectionTitle)
                        }}</span>
                        <span class="menu-arrow"></span>
                      </span>
                      <div
                        class="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px"
                      >
                        <template
                          v-for="(menuItem2, l) in menuItem1.sub"
                          :key="l"
                        >
                          <div class="menu-item">
                            <router-link
                              class="menu-link py-3"
                              active-class="active"
                              :to="menuItem2.route"
                            >
                              <span class="menu-bullet">
                                <span class="bullet bullet-dot"></span>
                              </span>
                              <span class="menu-title text-category">{{
                                translate(menuItem2.heading)
                              }}</span>
                            </router-link>
                          </div>
                        </template>
                      </div>
                    </div>
                    <div v-if="menuItem1.heading" class="menu-item">
                      <router-link class="menu-link py-3" :to="menuItem1.route">
                        <span class="menu-bullet">
                          <span class="bullet bullet-dot"></span>
                        </span>
                        <span class="menu-title text-category">{{
                          translate(menuItem1.heading)
                        }}</span>
                      </router-link>
                    </div>
                  </template>
                </div>
              </div>
              <div v-if="menuItem.heading" class="menu-item">
                <router-link class="menu-link py-3" :to="menuItem.route">
                  <span class="menu-title text-category">{{
                    translate(menuItem.heading)
                  }}</span>
                </router-link>
              </div>
            </template>
            <div v-if="item.heading == 'หลักสูตรตามกฎหมาย'">
              <template v-for="(menuItem, j) in listSyllabuses" :key="j">
                <router-link
                  class="menu-link py-3"
                  :to="'/course/mandatory-list/' + menuItem.id"
                >
                  <span class="menu-title text-category">{{
                    translate(menuItem.name)
                  }}</span>
                </router-link>
              </template>
            </div>
          </div>
        </div>
      </template>
      <!--end::Menu-->
    </div>
  </div>
  <!--end::Menu wrapper-->
</template>

<style lang="scss">
.menu-link {
  color: #5e6278;
  position: relative;
  transition: color 0.2s ease, background-color 0.2s ease;
  border-radius: 8px;
}

.menu-link.active {
  background-color: rgba(50, 53, 99, 0.08);
  color: #323563;

  .menu-title {
    color: #323563;
    font-weight: 600;
  }

  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 60%;
    height: 3px;
    background: #323563;
    border-radius: 3px 3px 0 0;
  }
}

.menu-link:hover:not(.disabled):not(.active) {
  background-color: rgba(50, 53, 99, 0.05);
  color: #323563;

  .menu-title {
    color: #323563;
  }
}

.menu-state-bullet-primary .menu-item .menu-link.active {
  background-color: rgba(50, 53, 99, 0.08);
}

.router-link-active.router-link-exact-active.menu-link {
  background-color: rgba(50, 53, 99, 0.08);
}

.menu-sub a.menu-link {
  color: #5e6278;
  border-radius: 6px;

  &:hover {
    background-color: rgba(50, 53, 99, 0.05);
    color: #323563;
  }

  &::after {
    display: none;
  }
}

/* mandatory theme overrides */
.header-mandatory {
  .menu-link {
    color: #ffffff;

    .menu-title {
      color: #ffffff !important;
    }
  }

  .menu-link.active {
    background-color: rgba(255, 255, 255, 0.15);

    .menu-title {
      color: #ffffff !important;
    }

    &::after {
      background: #ffffff;
    }
  }

  .menu-link:hover:not(.disabled):not(.active) {
    background-color: rgba(255, 255, 255, 0.1);

    // .menu-title {
    //   color: #ffffff !important;
    // }
  }
}

.menu-arrow-icon {
  display: inline-flex;
  transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);
  transform-origin: center;
  will-change: transform;
}

.menu-item.show > .menu-link > .menu-arrow-icon {
  transform: rotate(180deg);
}

@media (max-width: 991px) {
  .header-menu {
    background: #ffffff;
    padding: 12px 0 20px;
    overflow-y: auto;
  }

  .header-menu .menu-item > .menu-link {
    padding: 10px 16px;
    margin-bottom: 2px;
    border-radius: 8px;
    white-space: nowrap;
  }

  .header-menu .menu-item > .menu-link .menu-title {
    font-size: 14px;
    font-weight: 500;
    white-space: nowrap;
  }

  .header-menu .menu-sub .menu-link {
    padding: 8px 16px 8px 28px;
    white-space: nowrap;
  }

  .header-menu .menu-sub .menu-link .menu-title {
    font-size: 13px;
    white-space: nowrap;
  }

  .header-menu .menu-item.show > .menu-link {
    background-color: rgba(50, 53, 99, 0.06);
  }

  /* ซ่อน bottom underline ทั้งหมดใน drawer */
  .menu-item.menu-lg-down-accordion .menu-link::after,
  .router-link-active.router-link-exact-active.menu-link::after,
  .menu-link.active::after {
    display: none !important;
  }

  /* active state — pill style */
  .menu-item.menu-lg-down-accordion > .menu-link.active,
  .router-link-active.router-link-exact-active.menu-link.py-3,
  .menu-link.active {
    position: relative;
    background: rgba(50, 53, 99, 0.07) !important;
    border-left: none !important;
    border-radius: 10px !important;
    padding-left: 16px !important;
    box-shadow: none !important;
  }

  /* left accent dot */
  .menu-item.menu-lg-down-accordion > .menu-link.active::before,
  .router-link-active.router-link-exact-active.menu-link.py-3::before,
  .menu-link.active::before {
    content: "";
    position: absolute;
    left: 6px;
    top: 50%;
    transform: translateY(-50%);
    width: 4px;
    height: 60%;
    background: #323563;
    border-radius: 4px;
  }

  .menu-item.menu-lg-down-accordion > .menu-link.active .menu-title,
  .router-link-active.router-link-exact-active.menu-link.py-3 .menu-title,
  .menu-link.active .menu-title {
    color: #323563 !important;
    font-weight: 700;
  }
}
</style>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import { useRoute , useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import { MenuComponent } from "@/assets/ts/components";
import MainMenuConfig from "@/core/config/MainMenuConfig";
import { headerMenuIcons } from "@/core/helpers/config";
import axios from "axios";
const listSyllabuses = ref();
export default defineComponent({
  name: "KTMenu",
  components: {},
  setup() {
    const { t, te } = useI18n();
    const route = useRoute();
    const router = useRouter();
    const hasActiveChildren = (match) => {
      return route.path.indexOf(match) !== -1;
    };
    const checkActive = (match) => {
      if (match == "หลักสูตรตามกฎหมาย") {
        return route.path.indexOf("mandatory") !== -1;
      } else if (match == "ศูนย์ช่วยเหลือ") {
        if (
          route.path.indexOf("qaboard") > -1 ||
          route.path.indexOf("help") > -1 ||
          route.path.indexOf("contactus") > -1
        ) {
          return true;
        } else {
          return false;
        }
      }
    };
    const translate = (text) => {
      if (te(text)) {
        return t(text);
      } else {
        return text;
      }
    };

    onMounted(async () => {
      MenuComponent.reinitialization();
      await axios
        .get(
          process.env.VUE_APP_API_URL +
            "/getSyllabus?&sizeContents=10&page=0&orderBy=1&sort=1&enable=1",
          { headers: {
            token: localStorage.getItem("id_token")? localStorage.getItem("id_token") :localStorage.getItem("tokenGuest")
          } }
        )
        .then(({ data }) => {
          listSyllabuses.value = data.data.content;
        })
        .catch(({ error }) => {
          const preserveKeys = ["timer", ...Object.keys(localStorage).filter(k => k.startsWith("ExamQuestion_") || k.startsWith("ExamLearnQuestion_") || k.startsWith("examLearnAnswersList_") || k.startsWith("ExamAnswersList_"))];
          const preserved = preserveKeys.map(k => [k, localStorage.getItem(k) ?? ""]);
          localStorage.clear();
          preserved.forEach(([k, v]) => { if (v) localStorage.setItem(k, v); });
          router.go(0);
          // window.location.reload();
          console.log(error);
        });
    });

    return {
      hasActiveChildren,
      headerMenuIcons,
      MainMenuConfig,
      translate,
      route,
      listSyllabuses,
      checkActive,
    };
  },
});
</script>
